<template>
    <section class="gewerkt title">
        <ogt-video ref="video" src="/static/video/gewerkt.mp4" poster="/static/video/gewerkt-poster.jpg"></ogt-video>
        <h1>Hier werkten we aan in 2020</h1>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_title.scss
</style>

<script>
    import { gsap } from '@/vendor';

    import OgtVideo from '@/app/components/OgtVideo';
    import Overzicht from '@/app/pages/gewerkt/Overzicht.vue';

    export default {
        name: 'Gewerkt',
        meta: {
            title: '4. Hier werkten we aan in 2020',
            color: '#a5147e',
            slides: [ Overzicht ]
        },

        components: {
            'ogt-video': OgtVideo
        },

        mounted()
        {
            this.tl = gsap.timeline({ paused: true });
            this.tl.fromTo( 'section.gewerkt.title h1', { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.5 });
        },

        methods: {
            focus()
            {
                this.tl.play();
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            }
        }
    };
</script>
